import { render } from "./ApartmentsComparePage.vue?vue&type=template&id=84d054a4&scoped=true"
import script from "./ApartmentsComparePage.vue?vue&type=script&lang=js"
export * from "./ApartmentsComparePage.vue?vue&type=script&lang=js"

import "./ApartmentsComparePage.vue?vue&type=style&index=0&id=84d054a4&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d054a4"]])

export default __exports__